export { trackAuth, trackEvent, trackPageView } from 'web-services/segment';
